export enum VendorContractScope {
    UNSPECIFIED = 'unspecified',
    MAINTENANCE = 'maintenance',
    MAINTENANCE_AND_PARTS = 'maintenance-and-parts',
    SUBSTITUTE_CAR_CLASS_B = 'substitute-car-class-b',
    SUBSTITUTE_CAR_CLASS_C = 'substitute-car-class-c',
    SUBSTITUTE_CAR_CLASS_D = 'substitute-car-class-d',
    FUEL_CARD_CLASS_1 = 'fuel-card-class-1',
    FUEL_CARD_CLASS_2 = 'fuel-card-class-2',
    FUEL_CARD_CLASS_3 = 'fuel-card-class-3',
}
